import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponents = [
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/04/29/principle/sources-10-f-300hz.svg`,
          },
        },
        styles: {
          padding: "2%",
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/04/29/principle/sources-10-f-600hz.svg`,
          },
        },
        styles: {
          padding: "2%",
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/04/29/principle/sources-10-f-1khz.svg`,
          },
        },
        styles: {
          padding: "2%",
        },
      },
    },
  ],
];

export default components;
